<template>
    <div class="bgcolor bgpadding">
        <!-- <el-row> -->
        <!-- <el-col :sm="4" :md="4" :lg="4" :xl="4" style="min-height:10px"><div class="clearfix"></div></el-col> -->
            <!-- <el-col :sm="15" :md="15" :lg="15" :xl="15" style="box-sizing: border-box;float: none;margin: 0 auto;"> -->
            <div class="warp_container">
                <!-- <div class="order_top white_bg"> -->
                <div class="order_conter white_bg" v-if="orderData.course_is_textbook===1">
                    <!-- <div class="order_top_warp">
                        <div class="pay-jdL">
                            <div>提交订单</div>
                            <i></i>
                        </div>
                        <div class="pay-jd">
                            <span class="pay_tips">请在30分钟内完成支付！逾期将自动取消！</span>
                            <span class="pay-num"></span>
                        </div>
                        <div class="pay-jdL pay-jdR">
                            <div>完成支付</div>
                            <i></i>
                        </div>
                    </div> -->
                    <div class="order_title">
                        <div class="order_title_sub_box"><span>收货信息</span><span class="add_default_txt cursor" @click="toAddress">管理收货地址</span></div>
                    </div>
                    <div class="has_add_box" v-if="address_list.length>0">
                        <div v-for="(val,key) in address_list" :key="key">
                            <div class="add_item" :class="{'active_i_address':val.ad_id==ad_id}">
                                <div>
                                    <label :for="`radio${key}`" @click="activeAddress(val,$event)">
                                        <input type="radio" :value="val.ad_id" v-model="ad_id" :id="`radio${key}`" style="vertical-align: middle;margin-right: 8px"><span>{{`${val.ad_address}${val.ad_address_detail} (${val.ad_name}) ${val.ad_tel} `}}</span>
                                    </label>   
                                    <div class="default_txt_btn" v-if="val.ad_default==1">默认地址</div>
                                    <span class="add_default_txt cursor" v-else @click="setDefault(val)">设置为默认地址</span>
                                </div>
                                <div class="add_default_txt cursor" v-if="val.ad_id==ad_id" @click="editRow(val)">修改地址</div>
                            </div>
                        </div>
                        <div class="add_default_txt cursor" @click="addAddress">新建地址</div>
                    </div>
                    <div class="no_add_box" v-else>
                        <div class="no_add_left">
                            <div class="tab_area">
                                所在地区：
                                <v-distpicker
                                    @selected="sel"
                                    :province="province"
                                    :city="city"
                                    :area="area"
                                    @province="getProvince"
                                    @city="getCity"
                                    @area="getArea"
                                >
                                </v-distpicker>
                            </div>
                            <div class="add_txtarea top">
                                详细地址：<textarea v-model="address" placeholder="请输入详细地址信息，如道路、门牌号等"></textarea>
                            </div>
                            <div class="add_info_box top">
                                <div>收货人：
                                    <input
                                        class="add_ipt"
                                        v-model="username"
                                        type="text"
                                        placeholder="请输入收货人姓名"
                                    />
                                </div>
                                <div class="add_phone">手机号码：
                                    <input
                                        class="add_ipt"
                                        v-model="phone"
                                        type="number"
                                        placeholder="请输入收货人手机号"
                                        maxlength="11"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="no_add_right">
                            <div class="checkbox_wrap">
                                <label for="check">
                                    <input type="checkbox" class="defind_inpt" id="check" v-model="defineVal" value="默认" />默认
                                </label>
                            </div>
                            <div class="suer_add cursor" @click="submit_add">保存地址</div>
                        </div>
                    </div>
                </div>
                <div class="order_conter white_bg top">
                    <div class="order_title">订单详情</div>
                    <div class="order_mian clearfix">
                        <div class="mian_left"><img :src="orderData.course_img" alt=""></div>
                        <div class="mian_right">
                            <div class="ord_title">{{orderData.course_name}}</div>
                            <p class="ord_dec">{{orderData.course_subtitle}}</p>
                            <div>
                                <!-- <div class="kctime">开课时间：{{orderData.course_created_time}}~{{orderData.course_update_time}}</div> -->
                                <div class="jianjie"></div>
                                <div><span>价格：</span><span class="discount_price">￥{{orderData.course_discount_price}}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 优惠券 -->
                <div class="ticket white_bg top" v-if="(useful && useful.length>0)||(un_useful&&un_useful.length>0)">
                    <span class="ticket_txt">使用优惠券</span>
                    <div class="ticket_btn_wrap cursor">
                        <template v-for="(val,index) in useful">
                            <div class="ticket_btn useful" :class="{active_useful:select_flag&&val.coupon_sn===select.coupon_sn}" @click="active_useful(val)">抵扣{{val.waiver.waiver_amount}}元</div>
                        </template>
                        <template v-for="(item,idx) in un_useful">
                            <!-- <div class="ticket_btn un_useful">抵扣{{item.option.waiver_amount_1}}元</div> -->
                            <el-popover
                                placement="top-start"
                                :title="item.title+'：'"
                                width="200"
                                trigger="hover"
                                :content="item.cant_use_message+' (不可用)'">
                                <div class="ticket_btn un_useful" slot="reference" @click="active_useful(item)">抵扣{{item.option.waiver_amount_1}}元</div>
                            </el-popover>
                        </template>
                    </div>
                    
                </div>
                <!-- 优惠券结束 -->
                <div class="submt white_bg top">
                    <div class="submt_price">合计：<span class="discount_price">￥{{select? orderData.course_discount_price-select.waiver.waiver_amount:orderData.course_discount_price}}</span></div>
                    <div class="submt_btn" @click="submit">提交订单</div>
                </div>
            </div>
            <!-- </el-col> -->
        <!-- </el-row> -->
        <!-- <el-col :sm="4" :md="4" :lg="4" :xl="4" style="min-height:10px"><div class="clearfix"></div></el-col> -->
        <el-dialog
        :title="diologTitle"
        class="add_dialog_box"
        width="500px"
        :visible.sync="dialogAddress"
      >
        <table>
          <tr class="ad_tr">
            <td class="left_td">所在地区</td>
            <td class="right_td">
              <v-distpicker
                @selected="sel"
                :province="province"
                :city="city"
                :area="area"
                @province="getProvince"
                @city="getCity"
                @area="getArea"
              >
              </v-distpicker>
            </td>
          </tr>
          <tr class="ad_tr">
            <td class="left_td">详细地址</td>
            <td class="right_td">
              <input
                v-model="address"
                type="text"
                placeholder="请输入详细地址信息，如道路、门牌号等"
              />
            </td>
          </tr>
          <tr class="ad_tr">
            <td class="left_td">收货人姓名</td>
            <td class="right_td">
              <input
                v-model="username"
                type="text"
                placeholder="请输入收货人姓名"
              />
            </td>
          </tr>
          <tr class="ad_tr">
            <td class="left_td">手机号码</td>
            <td class="right_td">
              <input
                v-model="phone"
                type="number"
                placeholder="请输入收货人手机号"
                maxlength="11"
              />
            </td>
          </tr>
          <tr class="ad_tr">
            <td class="content_td" colspan="2">
              <label for="check">
                <input type="checkbox" class="td_inpt" id="check" v-model="defineVal" value="默认" />默认
              </label>
              
            </td>
          </tr>
        </table>
        

        <div class="add_btn cursor" @click="submit_add">保存并使用</div>
      </el-dialog>
    </div>
</template>

<script>
    // import VDistpicker from "v-distpicker";
    // import districts from "v-distpicker/src/districts";
    import VDistpicker from "@/components/v-distpicker/Distpicker";
    import districts from "@/components/v-distpicker/districts";
    import store from '../store'
    export default {
        components: { VDistpicker },
        data () {
            return {
                orderData:'',
                select: null,
                select_flag: false,
                useful: null,
                un_useful: null,
                phone: "",
                username: "",
                address: "",
                ad_id:"",
                province: "",
                city: "",
                area: "",
                area_code: "",
                region: "",
                defineVal: false,
                address_list: [],
                dialogAddress: false,
                isEdit: false,
            }
        },
        computed: {
            diologTitle() {
                return this.isEdit ? "编辑收货地址" : "新增收货地址";
            }
        },
        methods:{
            getData() {
                this.$http.get('/api/v2/course/getCourse',{
                    headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):''
                    },
                    params:{
                        course_id: this.$route.params.course_id
                    }
                })
                .then((res) => {
                    
                    if(res.data.code===1){
                        this.orderData=res.data.data;
                        if(this.orderData.course_is_textbook===1){
                            this.getDefaultAddress()
                        }
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                }).catch((err) => {
                    this.$message.error(err);
                })
            },
            getTicketList() { //优惠券列表
                this.$http.post('/api/v2/coupon_sn/getUserOrderCouponSn',
                    {
                        glists: [
                            {gid:this.$route.params.course_id}
                        ]
                    },
                    {
                        headers:
                            {
                                'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                            }
                    }
                ).then((res) => {
                    
                    if(res.data.code===1){
                        // this.best_select=res.data.data.best_select
                        this.useful=res.data.data.useful
                        this.un_useful=res.data.data.un_useful
                        if(res.data.data.best_select.coupon_sn){
                            this.select=res.data.data.best_select;
                            this.select_flag=true;
                        }
                        
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg)
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                
                }).catch((err) => {
                        this.$message.error(err);
                })
            },
            active_useful(item) {
                this.usefulDetection(item)
            },
            usefulDetection(item) {  //检测优惠券是否可用
                // this.$http({
                //     methods: 'post',
                //     url: '/api/v2/coupon_sn/checkUserOrderCouponSn',
                //     data: {
                //         glists:[
                //             {gid:this.$route.params.course_id}
                //         ],
                //         coupon_sn:sn
                //     },
                //     headers:{
                //         'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):''
                //     }
                // })
                this.$http.post('/api/v2/coupon_sn/checkUserOrderCouponSn',
                    {
                        glists: [
                            {gid:this.$route.params.course_id}
                        ],
                        coupon_sn:item.coupon_sn
                    },
                    {
                        headers:
                            {
                                'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                            }
                    }
                ).then((res) => {
                    
                    if(res.data.code===1){
                        
                        if(this.select){
                            if(item.coupon_sn===this.select.coupon_sn){
                                this.select_flag=false;
                                this.select=null;
                            }else{
                                this.select_flag=true;
                                this.select=res.data.data;
                            }
                        }else{
                            this.select_flag=true;
                            this.select=res.data.data;
                        }
                        
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg)
                        this.select_flag=false;
                        this.select=null;
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                
                }).catch((err) => {
                        this.$message.error(err);
                })
            },
            sel(data) {
                this.area_code = data.area.code;
                this.region = data.province.value + data.city.value + data.area.value;
            },
            getProvince(data){
                this.province=data.value
            },
            getCity(data){
                this.city=data.value
            },
            getArea(data){
                this.area=data.value
            },
            getDefaultAddress() {
                this.$http.get('/api/v2/address/getDefaultAddress',{
                    headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):''
                    }
                })
                .then(res => {
                    if(res.data.code===1){
                        // console.log(res,888888)
                        this.ad_id=res.data.data.ad_id
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
                .catch((err) => {
                    this.$message.error(err);
                })
            },
            submit() {
                var data={
                    gid: this.$route.params.course_id,
                    order_channel: 2
                }
                if(this.orderData.course_is_textbook===1){
                    if(this.ad_id){
                        data.address_id=this.ad_id
                    }else{
                        this.$message.error("请输入或选择收货地址");
                        return false;
                    }
                }
                if(this.select){
                    data.glists = [{
						gid: this.$route.params.course_id
					}]
                    data.coupon_sn_private=this.select.coupon_sn;
                }
                this.$http.post('/api/v2/course_order/createOrder',data,
                {
                    headers:
                    {
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    }
                }
                ).then((res) => {
                    
                    if(res.data.code===1){
                        if(res.data.data.created_order_exist===1){
                            var _this=this;
                            this.$msgbox({
                                title: '提示',
                                message: '该课程订单已存在，是否前往支付',
                                showCancelButton: true,
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                beforeClose:(action, instance, done) => {
                                    if(action==="confirm "){
                                        
                                    }else{
                                        done();
                                    }
                                }
                            }).then(action => {
                                this.$router.push({ path: "/me/order" });
                            })
                            return false
                        }
                        if(res.data.data.order_payment_type=="free"){
                            this.$message({
                                message: res.data.msg,
                                type: 'success'
                            });
                            this.$router.push({name:'courseDescription', params: {course_id:res.data.data.course_id}});
                            return false;
                        }
                        if (res.data.data.order_amount > 0) {
                            this.$router.push({path: '/pay',query: {course_id : this.$route.params.course_id, order_sn:res.data.data.order_sn}})
                        }else{
                            this.$router.push({path:'/accountPaid',query:{order_sn: res.data.data.order_sn}});
                        }
                        
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg)
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                
                }).catch((err) => {
                        this.$message.error(err);
                })

            },
            submit_add() {
                if (!/^1[0123456789]\d{9}$/.test(this.phone)) {
                    //验证手机号
                    this.$message.error("手机号码格式有误");
                    return false;
                }
                if (this.username.match(/^\s*$/)) {
                    this.$message.error("收货人不能为空或全空格");
                    return false;
                }
                if (this.region.match(/^\s*$/)) {
                    this.$message.error("地区不能为空");
                    return false;
                }
                if (this.address.match(/^\s*$/)) {
                    this.$message.error("详细地址不能为空");
                    return false;
                }
                if(this.isEdit){
                    var obj={
                        ad_id:this.ad_id,
                        ad_name: this.username,
                        ad_tel: this.phone,
                        ad_address: this.region,
                        ad_address_detail: this.address,
                        ad_area_code: this.area_code,
                        ad_default: this.defineVal ? 1:0
                    }
                    this.edit(obj)
                }else{
                    this.add()
                }
            },
            add(){
                this.$http.post("/api/v2/Address/add",
                    {
                        ad_name: this.username,
                        ad_tel: this.phone,
                        ad_address: this.region,
                        ad_address_detail: this.address,
                        ad_area_code: this.area_code,
                        ad_default: this.defineVal ? 1:0
                    },
                    {
                        headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                        }
                    }
                    )
                    .then(res => {
                    if (res.data.code === 1) {
                        this.$message({
                        message: res.data.msg,
                        type: "success"
                        });
                        this.get_address();
                        this.dialogAddress = false;
                        this.ad_id=res.data.data.ad_id
                        this.province = '省'
                        this.city = '市'
                        this.area = '区'
                        this.area_code = ''
                        this.username = ''
                        this.phone = ''
                        this.region = ''
                        this.address = ''
                        this.defineVal=false
                    } else if (res.data.code === 0) {
                        this.$message.error(res.data.msg);
                    } else if (res.data.code === 10001) {
                        store.commit("setDialogLogin", true);
                    }
                    })
                    .catch(err => {
                    this.$message.error(err);
                    });
            },
            edit(data){
                this.$http.post("/api/v2/Address/edit",
                {
                    ad_id: data.ad_id,
                    ad_name: data.ad_name,
                    ad_tel: data.ad_tel,
                    ad_address: data.ad_address,
                    ad_address_detail: data.ad_address_detail,
                    ad_area_code: data.ad_area_code,
                    ad_default: data.ad_default
                },
                {
                    headers: {
                    token:
                        localStorage.getItem("token") !== null
                        ? localStorage.getItem("token")
                        : ""
                    }
                }
                )
                .then(res => {
                if (res.data.code === 1) {
                    this.$message({
                    message: res.data.msg,
                    type: "success"
                    });
                    this.get_address();
                    this.dialogAddress = false;
                } else if (res.data.code === 0) {
                    this.$message.error(res.data.msg);
                } else if (res.data.code === 10001) {
                    store.commit("setDialogLogin", true);
                }
                })
                .catch(err => {
                this.$message.error(err);
                });
            },
            activeAddress(v,e) {
                // console.log(v,e)
                this.ad_id=v.ad_id
            },
            setDefault(e) {
                this.getEditArea(e.ad_area_code)
                var obj={
                    ad_id: e.ad_id,
                    ad_name: e.ad_name,
                    ad_tel: e.ad_tel,
                    ad_address: this.region,
                    ad_address_detail: e.ad_address_detail,
                    ad_area_code: e.ad_area_code,
                    ad_default: 1
                }
                this.edit(obj)
            },
            addAddress() {
                this.isEdit = false;
                this.dialogAddress = true;
                this.province = '省'
                this.city = '市'
                this.area = '区'
                this.area_code = ''
                this.username = ''
                this.phone = ''
                this.region = ''
                this.address = ''
                this.defineVal=false
                
            },
            editRow(data) {
                this.isEdit = true;
                this.dialogAddress = true;
                this.getEditArea(data.ad_area_code)
                this.ad_id = data.ad_id;
                this.area_code = data.ad_area_code;
                this.address = data.ad_address_detail
                this.username = data.ad_name
                this.phone = data.ad_tel
                this.defineVal = data.ad_default==1?true:false
            },
            getEditArea(val) {
                let province_code = val.substr(0, 2) + "0000",
                    city_code = val.substr(0, 4) + "00",
                    area_code = val;

                for (let i in districts["100000"]) {
                    if (i === province_code) {
                    this.province = districts["100000"][i];
                    }
                }

                for (let i in districts[province_code]) {
                    if (i === city_code) {
                    this.city = districts[province_code][i];
                    }
                }

                for (let i in districts[city_code]) {
                    if (i === area_code) {
                    this.area = districts[city_code][i];
                    }
                }
                this.region = this.province + this.city + this.area;
            },
            get_address() {
                this.$http
                .get("/api/v2/Address/getAddress", {
                //获取用户地址
                headers: {
                    token:
                    localStorage.getItem("token") !== null
                        ? localStorage.getItem("token")
                        : ""
                }
                })
                .then(res => {
                if (res.data.code === 1) {
                    this.address_list = res.data.data;
                } else if (res.data.code === 0) {
                    this.$message.error(res.data.msg);
                } else if (res.data.code === 10001) {
                    //登录检测
                    store.commit("setDialogLogin", true);
                }
                });
            },
            toAddress() {
                this.$router.push({path:'/me/address'})
            }
        },
        created() {
            this.getData();
            this.getTicketList()
            this.get_address()
        },
    }
</script>

<style scoped>
    .top{
        margin-top: 20px;
    }
    .order_top_warp{
        width: 520px;
        margin: 0 auto;
        height: 160px;
        padding: 20px 0;
        overflow: hidden;
        position: relative;
    }
    .pay-jdL {
        width: 100px;
        text-align: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .pay-jdL i {
        background: url('../assets/dingdan.png') no-repeat 0 0;
        background-size: cover;
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .pay-jdR i {
        background: url('../assets/dingdan2.png') no-repeat 0 0;
        background-size: cover;
    }
    /* .pay-jdL p {
        color: #47c88a;
        font-size: 16px;
    } */
    .pay-jdL div {
        color: #999;
        font-size: 18px;
        padding-bottom: 10px;
    }
    .pay-jdR {
        right: 0;
    }
    .pay-jd {
        width: 390px;
        height: 4px;
        background: #999999;
        float: left;
        position: absolute;
        top: 54%;
        left: 64px;
    }
    
    .pay-jd .pay-num {
        display: block;
        height: 4px;
        background: #ccc;
    }
    .pay_tips{
        position: absolute;
        left: 45px;
        bottom: 10px;
        color: #999999;
    }
    .default_txt_btn{
        display: inline-block;
        padding: 5px 10px;
        color: #ffffff;
        background: #00c590;
    }
    .add_default_txt{
        color: #02a7f0;
    }
    .has_add_box{
        font-size: 16px;
    }
    .add_item{
        display: flex;
        justify-content: space-between;
        padding: 12px 0;
        padding-right: 20px;
        align-items: center;
        margin-bottom: 14px;
    }
    .active_i_address{
        background: #fde7ca;
    }
    .no_add_box{
        font-size: 14px;
        display: flex;
    }
    .no_add_left{
        padding-right: 40px;
        border-right: 1px dashed #cccccc;
    }
    .no_add_right{
        padding-left: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .tab_area{
        display: flex;
        align-items: center;
    }
    .add_info_box{
        /* width: 600px; */
        display: flex;
    }
    textarea{
        width: 400px;
        height: 70px;
        resize: none;
        outline: none;
        vertical-align: top;
        border-radius: 8px;
        border: 1px solid #cccccc;
    }
    textarea::-webkit-scrollbar {
        display: none; /* 去滚动条 */
    }
    .add_phone{
        margin-left: 30px;
    }
    .defind_inpt{
        vertical-align: middle;
        margin-right: 5px;
    }
    .add_ipt{
        vertical-align: middle;
        border-radius: 8px;
        border: 1px solid #cccccc;
        padding: 10px;
        width: auto;
        box-sizing: border-box;
    }
    /* 数字输入框去掉上下选择 */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
    }
    input {
        -moz-appearance: textfield;
        outline: none;
    }
    .checkbox_wrap{
        width: 120px;
        text-align: center;
    }
    .suer_add{
        width: 120px;
        height: 40px;
        background: #00c590 ;
        border-radius: 8px;
        font-size: 20px;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        margin-top: 20px;
    }
    .order_conter{
        padding: 22px 30px 60px;
    }
    .order_title{
        font-size: 18px;
        color: #333333;
        border-left: 5px solid #00C590;
        padding-left: 9px;
        margin-bottom: 20px;
    }
    .order_title_sub_box{
        display: flex;
        justify-content: space-between;
    }
    .mian_right{
        color: #999999;
        font-size: 14px;
    }
    .ord_title{
        color: #333;
        font-size: 18px;
        margin: 20px 0;
    }
    .ord_dec{
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        color: #999999;
        font-size: 14px;
        margin-top: 0;
        margin-bottom: 26px;
    }
    .discount_price{
        color: #FF6F02;
        font-size: 30px;
    }
    .order_mian{
        display: flex;
        align-items: center;
    }
    .mian_left{
        min-width: 400px;
        max-width: 401px;
        height: 200px;
        margin-right: 50px;
        border-radius:10px;
    }
    .mian_left img{
        width: 100%;
        height: 100%;
    }
    
    .ticket{
        /* width:1200px; */
        height:90px;
        font-size: 18px;
        padding: 0 30px;
        position: relative;
    }
    .ticket_btn_wrap,.ticket_txt{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .ticket_btn_wrap{
        /* left: 190px; */
        left: 210px;
    }
    .useful{
        color: #333333;
        border: 1px solid #333333;
    }
    .un_useful{
        color: #999999;
        border:1px solid #999999;
    }
    .active_useful{
        border:1px solid #FF6F02;
        color: #FF6F02;
    }
    .ticket_btn{
        display: inline-block;
        width:150px;
        height:50px;
        line-height: 50px;
        border-radius:25px;
        text-align: center;
        margin-right: 60px;
    }
    
    .ticket_txt{
        left: 30px;
    }
    .submt{
        padding: 0 30px;
        height: 100px;
        width: 100%;
        box-sizing: border-box;
    }
    .submt_price{
        float: left;
        font-size: 18px;
        line-height: 100px;
    }
    .submt_btn{
        float: right;
        width:150px;
        height:50px;
        background:linear-gradient(30deg,rgba(255,142,2,1),rgba(255,111,2,1));
        border-radius:25px;
        font-size:20px;
        color: #ffffff;
        line-height: 50px;
        text-align: center;
        margin: 25px 0;
        cursor: pointer;
    }
    .ad_tr {
    margin-bottom: 30px;
    }
td {
  padding-bottom: 30px;
}
td input {
  border-radius: 8px;
  border: 1px solid #cccccc;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}
.right_td {
  padding-left: 20px;
  box-sizing: border-box;
}
.left_td {
  /* float: right; */
  text-align: right;
  padding-left: 40px;
}
.content_td{
  width: 100%;
  text-align: center;
}
.td_inpt{
  width: auto;
  vertical-align: middle;
  margin-right: 5px;
}
.add_btn {
  width: 120px;
  height: 40px;
  background: #ff6029;
  border-radius: 20px;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/page/SubmitOrder.vue